import { useContext, useEffect } from 'react'
import { withTheme } from 'emotion-theming'
import styled from '@emotion/styled'
import PropTypes from 'prop-types'
import ManageContext from 'contexts/ManageContext'
import smoothscroll from 'smoothscroll-polyfill'

import style from './ManageItem.style'

const ManageItemStyled = styled.button(props => ({ ...style(props) }))

const ManageItem = ({ text, icon, scrollTo }) => {
    const { serviceOffset, buildOffset, insureOffset, operateOffset, crewOffset, sellOffset } = useContext(
        ManageContext
    )

    let offsetValue

    useEffect(() => {
        switch (scrollTo) {
            case 'service':
                offsetValue = serviceOffset
                break
            case 'build':
                offsetValue = buildOffset
                break
            case 'insure':
                offsetValue = insureOffset
                break
            case 'operate':
                offsetValue = operateOffset
                break
            case 'crew':
                offsetValue = crewOffset
                break
            case 'sell':
                offsetValue = sellOffset
                break
            default:
                offsetValue = 0
        }
    }, [serviceOffset, buildOffset, insureOffset, operateOffset, crewOffset, sellOffset])

    const scrollToElement = () => {
        smoothscroll.polyfill()
        if (process.browser) {
            window.scrollTo({
                top: offsetValue,
                behavior: 'smooth'
            })
        }
    }

    return (
        <ManageItemStyled onClick={() => scrollToElement()}>
            <span className="ManageItemInner">
                {icon && <span className="Icon">{icon}</span>}
                <span className="Text">{text}</span>
            </span>
        </ManageItemStyled>
    )
}

ManageItem.propTypes = {
    text: PropTypes.string.isRequired,
    icon: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    scrollTo: PropTypes.string.isRequired
}

ManageItem.defaultProps = {
    icon: undefined
}

export default withTheme(ManageItem)
